import React from 'react'
import { Redirect } from 'react-router-dom'
import { Home } from './views/dashboard/Home'

import Facility from './views/dashboard/Facility'
import { Buildings } from './views/dashboard/Buildings'

import { CallCenterParent } from './views/dashboard/CallCenterParent'
import FacilityBuilder from './views/dashboard/FacilityBuilder'

import FacilityType from './views/dashboard/FacilityType'
import ApplicationType from './views/dashboard/ApplicationType'
import HospitalLoginMaster from './views/dashboard/HospitalLoginMaster'
import Keywords from './views/dashboard/Keywords'
import Scheduler from './views/dashboard/Scheduler'
import SchedulereMulti from './views/dashboard/SchedulereMulti'
import Dashboard from './views/dashboard/Dashboard'
import InsuranceForm from './views/dashboard/InsuranceMaster'

import LabMaster from './views/dashboard/LabMaster'
import PatientDashboard from './views/dashboard/PatientDashboard'
import Miscellaneous from './views/dashboard/Miscellaneous'
const retryDynamicImport = (loader, retries = 3, delay = 500) =>
  loader().catch((error) => {
    if (retries <= 0) throw error
    return new Promise((resolve) => {
      setTimeout(resolve, delay)
    }).then(() => retryDynamicImport(loader, retries - 1, delay * 2))
  })

const lazyWithRetry = (loader) => React.lazy(() => retryDynamicImport(loader))

const MainDashboard = lazyWithRetry(() => import('./views/dashboard/MainDashboard1'))
const NationalHighway = lazyWithRetry(() => import('./views/dashboard/NationalHighway'))
const HRMS = lazyWithRetry(() => import('./views/dashboard/HRMS'))
const RPMS = lazyWithRetry(() => import('./views/dashboard/RPMS'))
const GujRams = lazyWithRetry(() => import('./views/dashboard/GujRams'))
const Medicine = lazyWithRetry(() => import('./views/dashboard/Medicine'))
const GujMarg = lazyWithRetry(() => import('./views/dashboard/GujMarg'))
const HospitalLogin = lazyWithRetry(() => import('./views/dashboard/HospitalLogin'))
const Details = lazyWithRetry(() => import('./views/dashboard/Details'))
const ChildTable = lazyWithRetry(() => import('./views/dashboard/ChildTable'))
const Diagnosis = lazyWithRetry(() => import('./views/dashboard/Diagnosis'))
const Patient = lazyWithRetry(() => import('./views/dashboard/Patient'))
 
const Orderstab = lazyWithRetry(() => import('./views/dashboard/Orderstab'))
const Providers = lazyWithRetry(() => import('./views/dashboard/Provider'))

import { Questions } from './views/dashboard/Questions'
import ProviderInfo from './views/dashboard/ProviderInfo'
import ServiceLocationKareo from './views/dashboard/ServiceLocationKareo'

import PatientFormbuilder from './views/dashboard/PatientFormbuilder'

import Medication from './views/dashboard/Medication'
import Imaging from './views/dashboard/Imaging'
import RiskFactors from './views/dashboard/RiskFactors'
import DifferentialDiagnosis from './views/dashboard/DifferentialDiagnosis'
import SuggestionDiagnosis from './views/dashboard/SuggestionDiagnosis'
import AssesmentSuggestion from './views/dashboard/AssesmentSuggestion'
import Builder from './views/dashboard/Builder'
import ProviderQuestions from './views/dashboard/ProviderQuestions'
import ProviderMaster from './views/dashboard/ProviderMaster'
import CustomFormBuilder from './views/dashboard/CustomFormBuilder'
import Incident from './views/dashboard/Incident'
import PhysicalExamination from './views/dashboard/PhysicalExamination'
import MergeQuestion from './views/dashboard/MergeQuestion'
import MergeSuggestions from './views/dashboard/MergeSuggestions'
import Generalplanstatements from './views/dashboard/Generalplanstatement'
import Diagnosisdata from './views/dashboard/Diagnosisdata'
import PhysicalView from './views/dashboard/PhysicalView'
import PatientProviderAppointment from './views/dashboard/PatientProviderAppointment'
import SchedulePatient from './views/dashboard/SchedulePatient'
import AllAppointments2 from './views/dashboard/AllAppointments2'
 
import Appointments2 from './views/dashboard/Appointments2'
import ProviderAllPatient from './views/dashboard/ProviderAllPatient'
import SchedulePatient2 from './views/dashboard/SchedulePatient2'
import SchedulerMap from './views/dashboard/SchedulerMap'
import Analytics from './views/dashboard/Analytics'
import ProviderAnalytics from './views/dashboard/ProviderAnalytics'
import ProviderTodaysAppointment from './views/dashboard/ProviderTodaysAppointment'
import PatientInfo from './views/dashboard/PatientInfo'
import ProviderTodaysAppointment2 from './views/dashboard/ProviderTodaysAppointment2'
import ProviderTodaysAppointment3 from './views/dashboard/ProviderTodaysAppointment3'
 import TempKanban from './views/dashboard/kanban-components/tempkanban'

const Register = lazyWithRetry(() => import('./views/pages/Register/Register'))
const Users = lazyWithRetry(() => import('./views/dashboard/UserList'))
const Orders = lazyWithRetry(() => import('./views/dashboard/Orders'))
const RPMSRoads = lazyWithRetry(() => import('./views/datawarehouse/RPMSRoads'))
const ReportGenerator = lazyWithRetry(() => import('./views/dashboard/ReportGenerator'))
const FormBuilder = lazyWithRetry(() => import('./views/dashboard/Builder'))
const AddFacility = lazyWithRetry(() => import('./views/dashboard/AddFacility'))
const Educations = lazyWithRetry(() => import('./views/dashboard/Educations'))
const VerificationOtp = lazyWithRetry(() => import('./views/dashboard/VerificationsOtp'))
const FollowUpQuestion = lazyWithRetry(() => import('./views/dashboard/FollowUpQuestion'))
const kanbanBoard = lazyWithRetry(() => import('./views/dashboard/Kanbanboard'))
const backlogs = lazyWithRetry(() => import('./views/dashboard/Backlogs'))
const CallCenterForm = lazyWithRetry(() => import('./views/dashboard/CallCenterForm'))
const Credentialing = lazyWithRetry(() => import('./views/dashboard/Credentialing'))
import TempBacklog from './views/dashboard/Temp-Backlog'
import AdminBacklog from './views/dashboard/AdminBacklog'
import ProviderBacklog from './views/dashboard/ProviderBacklog'
import ProviderKanban from './views/dashboard/kanban-components/providerKanban'
 
 
import Archive from './views/dashboard/Archive'
const HRMProviderManagement = lazyWithRetry(() => import('./views/dashboard/hrm/HRMProviderManagement'))

const SchedulerMapPage = ({ location }) => (
  <SchedulerMap
    scheduledPatient={location?.state?.scheduledPatient || []}
    selectedProviderData={location?.state?.selectedProviderData || {}}
    selectedProvider={location?.state?.selectedProvider || null}
  />
)
const HRMProviderDetails = lazyWithRetry(() => import('./views/dashboard/hrm/HRMProviderDetails'))
const HRMLeaves = lazyWithRetry(() => import('./views/dashboard/hrm/HRMLeaves'))
const HRMOnboarding = lazyWithRetry(() => import('./views/dashboard/hrm/HRMOnboarding'))
const HRMHolidays = lazyWithRetry(() => import('./views/dashboard/hrm/HRMHolidays'))
const HRMOnboardingPreview = lazyWithRetry(() => import('./views/dashboard/hrm/HRMOnboardingPreview'))


const role = JSON.parse(localStorage.getItem('jwt_token'))

const userRole = role?.Role
const HRMHomeRedirect = () => <Redirect to="/home/hrm/providers" />

const routes = [
  { path: '/', exact: true, name: 'Home' },
  // { path: '*', exact: true, component: userRole === 'provider' ? PatientProviderAppointment : Appointments2, name: 'Facility' },
  { path: '/home/dashboard', exact: true, component: Dashboard, name: 'Dashboard' },


  { path: '/home/insurance', exact: true, component: InsuranceForm, name: 'Insuarance' },

  { path: '/home/formbuilder', exact: true, component: Builder, name: 'FormBuilder' },

  { path: '/home/callCenterForm', name: 'callCenterForm', component: CallCenterForm, exact: true },

  { path: '/home/orders', exact: true, component: Orders, name: 'orders' },

  { path: '/home/providerQuestions', exact: true, component: CustomFormBuilder, name: 'ProviderQuestions' },

  { path: '/home/incidentQuestions', exact: true, component: Incident, name: 'Incident' },

  { path: '/home/providerfollowups', exact: true, component: FollowUpQuestion, name: 'providerfollowups' },
  { path: '/home/physicalExaminations', exact: true, component: PhysicalExamination, name: 'PhysicalExaminations' },
  { path: '/home/questions', exact: true, component: MergeQuestion, name: 'Question' },

  { path: '/home/medication', exact: true, component: Medication, name: 'Medication' },

  { path: '/home/providermaster', exact: true, component: ProviderMaster, name: 'ProviderMaster' },
  { path: '/home/provider/appointment', exact: true, component: PatientProviderAppointment, name: 'PatientProviderAppointment' },
  { path: '/home/provider/today-appointment', exact: true, component: ProviderTodaysAppointment3, name: 'ProviderTodaysAppointment' },
 
  // { path: '/home/provider/today-appointment2', exact: true, component: ProviderTodaysAppointment3, name: 'ProviderTodaysAppointment' },
  // { path: '/home/provider/today-appointment-second', exact: true, component: ProviderTodaysAppointment2, name: 'ProviderTodaysAppointment' },
  { path: '/home/analytics', exact: true, component: Analytics, name: 'Analytics' },
  { path: '/home/provider/analytics', exact: true, component: ProviderAnalytics, name: 'Analytics' },
  { path: '/home/provider/all-patients', exact: true, component: ProviderAllPatient, name: 'ProviderAllPatient' },
  
 

  { path: '/home/imaging', exact: true, component: Imaging, name: 'Imaging' },

  { path: '/home/patientDashboard', exact: true, component: PatientDashboard, name: 'PatientDashboard' },
  { path: '/home/educations', exact: true, component: Educations, name: 'Educations' },
  { path: '/home/provider/educations', exact: true, component: Educations, name: 'Educations' },
  { path: '/home/medicine', exact: true, component: Medicine, name: 'Medicine' },
  { path: '/home/miscellaneous', exact: true, component: Miscellaneous, name: 'Miscellaneous' },
  { path: '/verification', exact: true, component: VerificationOtp, name: 'Otp' },

  { path: '/home/labsmaster', exact: true, component: LabMaster, name: 'LabsMaster' },
  { path: '/home/providerInfo', exact: true, component: ProviderInfo, name: 'ProviderInfo' },
  { path: '/home/patient', exact: true, component: Patient, name: 'Patient' },
  { path: '/home/archive-patients', exact: true, component: Archive, name: 'Archive' },
  // { path: '/home/appointment', exact: true, component: Appointment, name: 'Appointment' },
  { path: '/home/appointment', exact: true, component: Appointments2, name: 'Appointment' },

  { path: '/home/all-appointment', exact: true, component: AllAppointments2, name: 'All Appointment' },
  { path: '/home/patient-orders', exact: true, component: Orderstab, name: 'patient-orders' },
  { path: '/home/provider', exact: true, component: Providers, name: 'Provider' },
  { path: '/home/diagnosis', exact: true, component: Diagnosis, name: 'Diagnosis' },

  { path: '/home/report', exact: true, component: ReportGenerator, name: 'ReportGenerator' },
  { path: '/home/hospitalLogin', exact: true, component: HospitalLogin, name: 'HospitalLogin' },
  // { path: '/home/Scheduler', exact: true, component: Scheduler, name: 'Scheduler' },
  { path: '/home/Scheduler', exact: true, component: SchedulereMulti, name: 'Scheduler' },
  // { path: '/home/appointmentScheduler', exact: true, component: SchedulePatient, name: 'Appointment Scheduler' },
  { path: '/home/appointmentScheduler', exact: true, component: SchedulePatient2, name: 'Appointment Scheduler' },
  { path: '/home/schedulermap', exact: true, component: SchedulerMapPage, name: 'Scheduler Map' },

  { path: '/home/serviceLocation', exact: true, component: ServiceLocationKareo, name: 'Service Location' },

  { path: '/home/patient-info', name: 'PatientInfo', component: PatientInfo, exact: true },

  { path: '/home/hospitalLoginMaster', exact: true, component: HospitalLoginMaster, name: 'HospitalLoginMaster' },
  { path: '/home/risks', exact: true, component: RiskFactors, name: 'RisksFactor' },
  { path: '/home/diagnosis-data', exact: true, component: Diagnosisdata, name: 'Diagnosisdata' },
  { path: '/home/differentialDiagnosis', exact: true, component: DifferentialDiagnosis, name: 'DifferentialDiagnosis' },
  { path: '/home/template-plan-statement', exact: true, component: Generalplanstatements, name: 'treatment-plan' },
  { path: '/home/suggestionDiagnosis', exact: true, component: SuggestionDiagnosis, name: 'SuggestionDiagnosis' },
  // { path: '/home/kanban', exact: true, component: kanbanBoard, name: 'kanbanBoard' },
  { path: '/home/kanban/:id', exact: true, component: TempKanban, name: 'kanbanBoard' },
  { path: '/home/providerKanban/:id', exact: true, component: ProviderKanban, name: 'providerKanbanBoard' },
  // { path: '/home/backlogs', exact: true, component: backlogs, name: 'backlogs' },
  // { path: '/home/assessmentSuggestions', exact: true, component: AssesmentSuggestion, name: 'AssesmentSuggestion' },
  { path: '/home/backlogs', name: 'tempkanban', component: TempBacklog, exact: true },
  { path: '/home/assessmentSuggestions', exact: true, component: MergeSuggestions, name: 'Suggestions' },
  { path: '/home/physicalView', exact: true, component: PhysicalView, name: 'PhysicalView' },

  { path: '/home/facilityMap', exact: true, component: AddFacility, name: 'AddFacility' },

  { path: '/home/facility', exact: true, component: Facility, name: 'Facility' },
  { path: '/home/credentialing', exact: true, component: Credentialing, name: 'Credentialing' },

  { path: '/home/facilityType', exact: true, component: FacilityType, name: 'FacilityType' },
  { path: '/home/applicationType', exact: true, component: ApplicationType, name: 'ApplicationType' },

  { path: '/home/facilityBuilder', exact: true, component: FacilityBuilder, name: 'FacilityBuilder' },
  { path: '/home/patientFormbuilder', exact: true, component: PatientFormbuilder, name: 'Patient Form Builder' },
  { path: '/home/hrm', exact: true, component: HRMHomeRedirect, name: 'HRM' },
  { path: '/home/hrm/providers', exact: true, component: HRMProviderManagement, name: 'HRMProviderManagement' },
  { path: '/home/hrm/providers/:id', exact: true, component: HRMProviderDetails, name: 'HRMProviderDetails' },
  { path: '/home/hrm/leaves', exact: true, component: HRMLeaves, name: 'HRMLeaves' },
  { path: '/home/hrm/holidays', exact: true, component: HRMHolidays, name: 'HRMHolidays' },
  { path: '/home/hrm/onboarding', exact: true, component: HRMOnboarding, name: 'HRMOnboarding' },
  { path: '/home/hrm/onboarding-preview', exact: true, component: HRMOnboardingPreview, name: 'HRMOnboardingPreview' },

  { path: '/dashboard/callcenter', exact: true, component: CallCenterParent, name: 'CallCenterParent' },
  { path: '/dashboard/keywords', exact: true, component: Keywords, name: 'Keywords' },
  // { path: '/dashboard', name: 'RPMS', component: RPMS, exact: true },
  // { path: '/dashboard/hrms', name: 'HRMSDashboard', component: HRMS, exact: true },
  { path: '/dashboard/frmbuilder', name: 'FormBuilder', component: FormBuilder, exact: true },

  // { path: '/dashboard/wms', name: 'WMS', component: MainDashboard, exact: true },
  // { path: '/dashboard', name: 'RPMS', component: RPMS, exact: true },
  // { path: '/dashboard/gujrams', name: 'GujRams', component: GujRams, exact: true },
  // { path: '/dashboard/gujmarg', name: 'GujMarg', component: GujMarg, exact: true },
  // { path: '/dashboard/nh', name: 'NationalHighway', component: NationalHighway, exact: true },
  { path: '/details', name: 'Details', component: Details },
  { path: '/questions', name: 'Questions', component: Questions },

  { path: '/register', name: 'Register', component: Register, exact: true },
  { path: '/home/users', name: 'Users', component: Users, exact: true },
  { path: '/childTable', name: 'ChildTable', component: ChildTable },
  { path: '/datawarehouse', name: 'RPMS Works', component: RPMSRoads, exact: true },
  { path: '/datawarehouse/RPMS/:data', name: 'RPMS Works', component: RPMSRoads, exact: true },
  { path: '/home/all-tasks', name: 'adminkanban', component: AdminBacklog, exact: true },
  { path: '/dashboard/tempBacklog', name: 'tempkanban', component: TempBacklog, exact: true },

  { path: '/home/providerBacklog', name: 'providerkanban', component: ProviderBacklog, exact: true },
]

export default routes
